/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { EmailPasswordLoginParams, SetStage, SetState } from './Types';

export const validateParams = (params?: any): void => {
  if (!params) {
    throw new Error('Params must be populated.');
  }
};

export const validateSetStage = (setStage: SetStage): void => {
  if (!setStage || typeof setStage !== 'function') {
    throw new Error('setStage must be populated.');
  }
};

export const validateSetState = (setState: SetState): void => {
  if (!setState || typeof setState !== 'function') {
    throw new Error('setState must be populated.');
  }
};

export const validateEmailPasswordLoginParams = (
  params: EmailPasswordLoginParams,
): void => {
  validateParams(params);
  validateSetStage(params.setStage);
};
